var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-288 412.9 19 16",
    style: {
      enableBackground: "new -288 412.9 19 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-269 414.7c-.7.3-1.5.5-2.2.6.8-.5 1.4-1.3 1.7-2.2-.8.5-1.6.8-2.5.9-1.5-1.6-3.9-1.7-5.5-.2-1 1-1.4 2.4-1.1 3.7-3.1-.2-6.1-1.6-8-4.1-.3.6-.5 1.3-.5 2 0 1.4.7 2.5 1.7 3.2-.6 0-1.2-.2-1.8-.5 0 1.9 1.3 3.5 3.1 3.8-.6.2-1.2.2-1.8.1.5 1.6 2 2.7 3.6 2.7-1.6 1.3-3.7 1.9-5.8 1.6 1.8 1.1 3.9 1.8 6 1.8 7.2 0 11.1-5.9 11.1-11.1v-.5c.8-.3 1.5-1 2-1.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.ef10c490899dd5f4d5d6c945e7f4be72.svg";
export { ForwardRef as ReactComponent };